import { useContext } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

import { AuthContext } from '../../../context/auth';

import { registerUser } from '../../../services/user/userService.js';
import { registerSchema, loginSchema } from '../../../schemas/userSchema.js';

import alert from '../../../utils/alert.js';

import Button from '../../Button';
import { Input } from '../../Input';

import './styles.sass';

const UserForm = ({ setShowModal, isFormRegister }) => {
  const { handleLogin } = useContext(AuthContext);

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      firstUserName: '',
      email: '',
      password: '',
    },
    resolver: yupResolver(isFormRegister ? registerSchema : loginSchema),
  });

  const onSubmit = async (data) => {
    if (isFormRegister) {
      const statusRegister = await registerUser(data);

      if (statusRegister.success) {
        if (statusRegister?.emailExists) {
          alert.error('error', 'Oops...', 'Este e-mail já está cadastrado.');
          return;
        }

        alert.success('Cadastrado realizado com sucesso!');

        setShowModal(false);
      } else {
        alert.error(
          'info',
          'Erro ao realizar o cadastro.',
          'Por favor tente novamente mais tarde.'
        );
      }

      return;
    }

    const statusLogin = await handleLogin(data.email, data.password);

    switch (statusLogin) {
      case 'ok':
        setShowModal(false);
        break;

      case 'failed':
        alert.error('error', 'Oops...', 'Verifique seu e-mail ou senha.');
        break;

      default:
        alert.error(
          'info',
          'Erro ao realizar login',
          'Tente novamente mais tarde.'
        );
        break;
    }
  };

  return (
    <div className="mainLogin">
      <h1>{isFormRegister ? 'Cadastre-se' : 'Faça seu login'}</h1>
      <form onSubmit={handleSubmit(onSubmit)} id="loginForm">
        {isFormRegister && (
          <Input
            name="firstUserName"
            label="Primeiro nome"
            className="inputFirstUserName"
            control={control}
            type="text"
            placeholder="seu nome"
            errors={errors}
          />
        )}

        <Input
          name="email"
          label="Email"
          className="inputEmail"
          control={control}
          type="email"
          placeholder="usuario@email.com"
          errors={errors}
        />

        <Input
          name="password"
          label="Senha"
          className="inputPassword"
          control={control}
          type="password"
          placeholder="senha"
          errors={errors}
        />

        <div className="containerBtnRow">
          {isFormRegister ? (
            <Button
              type="submit"
              className="btn"
              disabled={isSubmitting}
              text={isSubmitting ? 'Cadastrando...' : 'Cadastrar'}
            />
          ) : (
            <>
              <Button
                type="submit"
                className="btn"
                disabled={isSubmitting}
                text={isSubmitting ? 'Entrando...' : 'Entrar'}
              />

              <Button
                type="button"
                className="btn"
                disabled={isSubmitting}
                text="Esqueci a senha"
                onClick={alert.unavailable}
              />
            </>
          )}
        </div>
      </form>
    </div>
  );
};

export default UserForm;
